import React, { useEffect, useState } from "react";
import "./Birthday.css";
import ls from "local-storage";

export const Birthdatecard = (props) => {
  // Handle Multiple Users
  const users = props.users || [];

  // Create comma-separated string of names: "Amit, Rahul & Priya"
  let Name = "User";
  if (users.length > 0) {
    Name = users.map(u => u.firstName).join(" , ");
  } else {
    Name = props.name || (ls("user") ? ls("user").firstName : "User");
  }

  // Photo Cycling Logic
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    if (users.length > 1) {
      const interval = setInterval(() => {
        setPhotoIndex((prev) => (prev + 1) % users.length);
      }, 2500); // Change photo every 2.5s
      return () => clearInterval(interval);
    }
  }, [users]);

  // Determine current photo to display
  const currentPhoto = users.length > 0 ? users[photoIndex].photo : props.photo;

  // Reset animation key on re-render
  const [key, setKey] = useState(0);
  useEffect(() => { setKey(prev => prev + 1); }, [Name]);

  return (
    <div className="birthday-card" key={key} onClick={() => setKey(prev => prev + 1)} style={{ cursor: 'pointer' }}>
      <div className="card">
        {/* Confetti Layer */}
        <div className="confetti-layer">
          {[...Array(15)].map((_, i) => (
            <div key={i} className={`confetti-piece c-${i + 1}`}></div>
          ))}
        </div>

        {/* Giant Cupcake (Left Side) */}
        <div className="cake-container">
          <div className="cupcake">
            <div className="cupcake-liner"></div>
            <div className="muffin-top"></div>
            <div className="frosting-stack">
              <div className="frosting f-1"></div>
              <div className="frosting f-2"></div>
              <div className="frosting f-3"></div>
              <div className="sprinkle s1"></div>
              <div className="sprinkle s2"></div>
              <div className="sprinkle s3"></div>
              <div className="sprinkle s4"></div>
              <div className="sprinkle s5"></div>
            </div>
            <div className="candle-spot">
              <div className="magic-candle">
                <div className="magic-flame"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Story Animation Section (Right Side) */}
        <div className="magic-text">
          {currentPhoto ? (
            <div className="story-photo-wrapper">
              <img key={photoIndex} src={currentPhoto} alt="Birthday User" className="story-profile-pic fade-photo" />
            </div>
          ) : null}

          <div className="story-content-wrapper">
            <h2 className="intro-text">It's a Special Day!</h2>
            <div className="title-group">
              <h1 className="name-reveal">
                Happy Birthday, <br />
                <span>{Name}</span>
              </h1>
            </div>
            <div className="wish-note-container">
              <p className="main-wish">
                I hope your special day will bring you lots of happiness, love, and fun. You deserve them a lot. Enjoy!
              </p>
              <p className="sub-wish">Hope your day goes great!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
